import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  loading: false,
  location: {
    lat: 18.6702551,
    lng: 73.7846511,
    address: "",
    distanceKm: 0,
    deliverable: false,
    time: 0
  },
  orderType: "takeaway", // delivery | takeaway | dine-in
};

export const localSlice = createSlice({
  name: "local",
  initialState,
  reducers: {
    setLocation: (state, action) => {
      state.location = action.payload;
    },

    setOrderType: (state, action) => {
      state.orderType = action.payload;
    },

    clearLocation: (state) => {
      state.location = initialState.location;
    },
  },
});

export const {
  setLocation,
  setOrderType,
  clearLocation,
} = localSlice.actions;

export default localSlice.reducer;
